import {
  PAGE as pageContentType,
} from 'config/types/content';

export const LANGUAGE_EDITION = 'LANGUAGE_EDITION';
export const HOME = 'HOME';
export const PAGE = 'PAGE';
export const CONTENT_ITEM_SINGLE = 'CONTENT_ITEM_SINGLE';
export const CONTENT_ARCHIVE = 'CONTENT_ARCHIVE';
export const TERM_ARCHIVE = 'TERM_ARCHIVE';
export const CATEGORY_ARCHIVE = 'CATEGORY_ARCHIVE';
export const AUTHOR_ARCHIVE = 'AUTHOR_ARCHIVE';
export const SEARCH_ARCHIVE = 'SEARCH_ARCHIVE';

// Defines the order that paths should be matched against, with more specific
// paths taking precedence over less specific paths
export const pathTypeOrder = [
  SEARCH_ARCHIVE,
  AUTHOR_ARCHIVE,
  CONTENT_ARCHIVE,
  CATEGORY_ARCHIVE,
  TERM_ARCHIVE,
  CONTENT_ITEM_SINGLE,
  HOME,
  PAGE,
];

// Defines the order that global paths (including language edition path)
// should be matched against. This excludes page, as page is our catch-all fallback pattern.
export const editionPathTypeOrder = [
  SEARCH_ARCHIVE,
  AUTHOR_ARCHIVE,
  CONTENT_ARCHIVE,
  TERM_ARCHIVE,
  CATEGORY_ARCHIVE,
  CONTENT_ITEM_SINGLE,
  HOME,
];

// Defines the pathTypes that are content archives.
export const archivePaths = [
  CONTENT_ARCHIVE,
  CATEGORY_ARCHIVE,
  TERM_ARCHIVE,
  AUTHOR_ARCHIVE,
  SEARCH_ARCHIVE,
];

// Defines the pathTypes that are content singles, and
// maps them to a specific content type if applicable.
export const contentItemPathTypeMap = {
  [CONTENT_ITEM_SINGLE]: null,
  [PAGE]: pageContentType,
};

export default {
  LANGUAGE_EDITION,
  HOME,
  PAGE,
  CONTENT_ITEM_SINGLE,
  CONTENT_ARCHIVE,
  CATEGORY_ARCHIVE,
  TERM_ARCHIVE,
  AUTHOR_ARCHIVE,
  SEARCH_ARCHIVE,
};
